import React, { useState } from 'react';
import { X, Key, Eye, EyeOff } from 'lucide-react';
import { validatePassword } from '../utils/userValidation';

export default function PasswordResetModal({ user, onReset, onClose }) {
  const [password, setPassword]               = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword]       = useState(false);
  const [error, setError]                     = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    const validation = validatePassword(password, true);
    if (!validation.valid) { setError(validation.error); return; }
    if (password !== confirmPassword) { setError('Las contraseñas no coinciden'); return; }
    onReset(password);
  };

  const inputCls = `w-full px-3 py-2 text-sm border rounded-lg focus:outline-none focus:border-blue-400 bg-white ${error ? 'border-red-300' : 'border-gray-200'}`;

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-md">

        {/* Header */}
        <div className="flex items-center justify-between px-5 py-4 border-b border-gray-100">
          <div className="flex items-center gap-2">
            <Key size={16} className="text-gray-400" />
            <div>
              <h3 className="text-sm font-bold text-gray-900">Cambiar contraseña</h3>
              <p className="text-xs text-gray-400">{user.username}</p>
            </div>
          </div>
          <button onClick={onClose} className="p-1.5 hover:bg-gray-100 rounded-lg transition-colors">
            <X size={15} className="text-gray-400" />
          </button>
        </div>

        {/* Content */}
        <form onSubmit={handleSubmit} className="p-5 space-y-4">
          <div>
            <label className="block text-xs font-medium text-gray-500 mb-1.5">
              Nueva contraseña <span className="text-red-400">*</span>
            </label>
            <div className="relative">
              <input
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="Mínimo 6 caracteres"
                className={inputCls + ' pr-9'}
                autoFocus
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-2.5 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
              >
                {showPassword ? <EyeOff size={15} /> : <Eye size={15} />}
              </button>
            </div>
          </div>

          <div>
            <label className="block text-xs font-medium text-gray-500 mb-1.5">
              Confirmar contraseña <span className="text-red-400">*</span>
            </label>
            <input
              type={showPassword ? 'text' : 'password'}
              value={confirmPassword}
              onChange={e => setConfirmPassword(e.target.value)}
              placeholder="Repetir contraseña"
              className={inputCls}
            />
          </div>

          {error && (
            <p className="text-xs text-red-500 bg-red-50 border border-red-100 rounded-lg px-3 py-2">{error}</p>
          )}

          <p className="text-xs text-amber-700 bg-amber-50 border border-amber-100 rounded-lg px-3 py-2">
            La contraseña se cambiará de inmediato. El usuario deberá usarla en su próximo inicio de sesión.
          </p>

          <div className="flex items-center justify-end gap-3 pt-1">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-sm text-gray-600 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors"
            >
              Cancelar
            </button>
            <button
              type="submit"
              className="px-5 py-2 text-sm font-semibold bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
            >
              Guardar contraseña
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
